
import { useMemo } from 'react';

import { PRECISION8 } from '@constants/index';

import { useAssetAccountMap0 } from './useAssetAccountMap0';
/** 获取币种账号保留位数 */
export const usePrecision = ({ coinCode }) => {
  const assetAccount = useAssetAccountMap0();
  const precision = useMemo(() => {
    return assetAccount.find(item => item.coinCode === coinCode)?.showKeepDecimalForCoin ?? PRECISION8
  }, [assetAccount, coinCode])
  return precision;
}
